import React from 'react';
import moment from 'moment';
import { string } from 'prop-types';

import activityShape from '../../../../shapes/activity-shape';
import ActivityCommentForm from './activity-comment-form';
import ActivityComment from './activity-comment';
import InfoSection from '../card-shared-components/card-info-section/card-info-section';
import { ACTIVITY_THREAD_SORT_OPTIONS } from '../../../../constants';

/**
 * Component for showing comments / performing an action a given activity.
 * This component should be used in ActivityWrapper - and potentially
 * shown in the activity history widget.
 * @param {object} params - Object container props for this component
 * @param {object} params.activity - Activity object.
 * @param {object} params.sort - The Sort order of the activities comments
 * @returns {element}
 */
const ActivityThread = ({ activity, sort }) => {
  const sortComments = (comments) => {
    const result = [...comments];
    switch (sort) {
      case ACTIVITY_THREAD_SORT_OPTIONS.asc:
        result.sort((a, b) => (
          moment(a.createdAt).isSameOrAfter(b.createdAt) ? 1 : -1
        ));
        break;
      case ACTIVITY_THREAD_SORT_OPTIONS.desc:
        result.sort((a, b) => (
          moment(a.createdAt).isSameOrAfter(b.createdAt) ? -1 : 1
        ));
        break;
      default:
        return result;
    }
    return result;
  };

  return (
    <InfoSection testId="activity-thread" removePadding>
      <ActivityCommentForm eventId={activity.eventId} loadId={activity.loadId} />
      {activity.comments ? sortComments(activity.comments).map((comment, i) => (
        <ActivityComment key={comment.commentId} alternateBackground={i % 2 === 1} comment={comment} />
      )) : <> </>}
    </InfoSection>
  );
};

ActivityThread.propTypes = {
  activity: activityShape.isRequired,
  sort: string,
};

ActivityThread.defaultProps = {
  sort: ACTIVITY_THREAD_SORT_OPTIONS.desc,
};

export default ActivityThread;
